import { render, staticRenderFns } from "./overtimeTaking.vue?vue&type=template&id=21518530&scoped=true"
import script from "./overtimeTaking.vue?vue&type=script&lang=js"
export * from "./overtimeTaking.vue?vue&type=script&lang=js"
import style0 from "./overtimeTaking.vue?vue&type=style&index=0&id=21518530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21518530",
  null
  
)

export default component.exports